import type { FC, ReactNode } from 'react'

import { useState } from 'react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { SectionCard } from '@/components/dashboard/section-card'

type NotificationKey = 'weekly' | 'failed' | 'newCustomer' | 'churnRisk' | 'monthly' | 'team'

const OPTIONS: { key: NotificationKey, label: string, description: string }[] = [
    { key: 'failed', label: 'Pembayaran gagal', description: 'Segera, setiap kali tagihan pelanggan gagal dibayar.' },
    { key: 'churnRisk', label: 'Akun berisiko churn', description: 'Saat skor kesehatan pelanggan turun di bawah 40.' },
    { key: 'newCustomer', label: 'Pelanggan baru', description: 'Saat ada pelanggan baru memilih paket berbayar.' },
    { key: 'weekly', label: 'Ringkasan mingguan', description: 'Setiap Senin pukul 08.00 WIB: MRR, churn, dan pelanggan baru.' },
    { key: 'monthly', label: 'Laporan bulanan', description: 'Tanggal 1 setiap bulan, lengkap dengan analisis kohort.' },
    { key: 'team', label: 'Aktivitas tim', description: 'Saat anggota tim bergabung, keluar, atau berganti peran.' }
]

const INITIAL: Record<NotificationKey, boolean> = {
    weekly: true,
    failed: true,
    newCustomer: true,
    churnRisk: true,
    monthly: false,
    team: false
}

export const NotificationsForm: FC = (): ReactNode => {
    const [saved, setSaved] = useState(INITIAL)
    const [values, setValues] = useState(INITIAL)
    const dirty = OPTIONS.some((option) => values[option.key] !== saved[option.key])
    const enabledCount = OPTIONS.filter((option) => values[option.key]).length

    return (
        <SectionCard
            title='Notifikasi email'
            description={`Pilih kabar yang dikirim ke email Anda. ${enabledCount} dari ${OPTIONS.length} aktif.`}
            footer={(
                <div className='flex flex-wrap items-center justify-end gap-2'>
                    <Button variant='ghost' disabled={!dirty} onClick={() => setValues(saved)}>
                        Batalkan
                    </Button>
                    <Button
                        disabled={!dirty}
                        onClick={() => {
                            setSaved(values)
                            toast.success('Preferensi notifikasi disimpan')
                        }}
                    >
                        Simpan perubahan
                    </Button>
                </div>
            )}
        >
            <ul className='divide-y'>
                {OPTIONS.map((option) => (
                    <li key={option.key} className='flex items-start justify-between gap-6 py-4 first:pt-0 last:pb-0'>
                        <div className='min-w-0'>
                            <Label htmlFor={`notify-${option.key}`} className='text-sm font-medium'>
                                {option.label}
                            </Label>
                            <p id={`notify-${option.key}-description`} className='mt-1 text-xs leading-relaxed text-muted-foreground'>
                                {option.description}
                            </p>
                        </div>

                        <Switch
                            id={`notify-${option.key}`}
                            checked={values[option.key]}
                            onCheckedChange={(checked) => setValues((current) => ({ ...current, [option.key]: checked }))}
                            aria-describedby={`notify-${option.key}-description`}
                            className='mt-0.5'
                        />
                    </li>
                ))}
            </ul>
        </SectionCard>
    )
}
